module.exports = __webpack_public_path__ + "img/testImage7.469f1c40.469f1c40.png";